import type * as React from 'react';

import { DimeSheet, DimeSheetContent, DimeSheetHeader, DimeSheetTitle } from '../DimeSheet.js';

type DimeDetailLayoutLeftPaneSheetProps = Readonly<{
  title: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
}>;

export function DimeDetailLayoutLeftPaneSheet({
  title,
  open,
  onOpenChange,
  children,
}: DimeDetailLayoutLeftPaneSheetProps) {
  return (
    <DimeSheet open={open} onOpenChange={onOpenChange}>
      <DimeSheetContent side="left" className="w-[85vw] max-w-sm p-0">
        <DimeSheetHeader className="sr-only">
          <DimeSheetTitle>{title}</DimeSheetTitle>
        </DimeSheetHeader>
        {children}
      </DimeSheetContent>
    </DimeSheet>
  );
}
